import React from 'react';
import { Route, Switch } from 'react-router-dom';

import FCFianca from '../../pages/operational/fcfianca/FCFianca';

export default () => (
  <Switch>
    <Route exact path="/intranet/garantias/fcfianca" component={FCFianca} />
  </Switch>
);
